import { VeltComments, VeltCommentTool } from '@veltdev/react';
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import './CommentPage.css';

function CommentPage() {

    const [searchParams] = useSearchParams();
    const [isLandingPageDemo, setIsLandingPageDemo] = useState(false);

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    useEffect(() => {
        if (searchParams.get('landingPageDemo')) {
            setIsLandingPageDemo(true);
        }
    }, [searchParams]);

    return (
        <>
            <VeltComments />
            <div className="comment-tool-container">
                {
                    isLandingPageDemo ?
                    null :
                    <p className='boujeeText'>Click the Comment Tool in the bottom right to add a comment anywhere.</p>
                }
                <VeltCommentTool />
            </div>
        </>
    )
}

export default CommentPage;